import { render, staticRenderFns } from "./AdminRetirement.vue?vue&type=template&id=233f0d9c&scoped=true&"
import script from "./AdminRetirement.vue?vue&type=script&lang=js&"
export * from "./AdminRetirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233f0d9c",
  null
  
)

export default component.exports